<template>
  <div id="wanfoshenqiye">
    <NavBar />

    <div id="hero" class="hero overlay subpage-hero">
      <div class="hero-content">
        <div class="hero-text">
          <h1>万佛神奇液</h1>
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/">首页</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link to="/products">产品</router-link>
            </li>
            <li class="breadcrumb-item active">万佛神奇液</li>
          </ol>
        </div>
        <!-- /.hero-text -->
      </div>
      <!-- /.hero-content -->
    </div>
    <!-- /.hero -->

    <main id="main" class="site-main">
      <section class="site-section subpage-site-section section-project">
        <div class="container">
          <div class="row">
            <div class="col-md-12 mb-4">
              <div class="project-img">
                <img
                  :src="require('@/assets/img/products/wan-fo-shen-qi-ye.jpg')"
                  class="img-res mx-auto"
                  alt=""
                />
              </div>
              <!-- /.project-img -->
            </div>
            <aside class="col-md-12">
              <div class="project-info text-justify">
                <h5>『万佛神奇液』</h5>

                <p class="project-description">
                  『万佛神奇液』由著名玄学家苗大精心配制的最新招财纳福圣品。『万佛神奇液』是以七种珍贵异花和香橼，经过苗大大力加
                  持施法，成功研制。由於，『万佛神奇液』是以七种珍贵异花和香橼配制，味道芬芳，香橼味清新自然，只要使用者，在沐浴时，洒一瓶『万佛神奇液』搅匀清水
                  中，从头洗到脚，便具有—祛除霉运转好运的奇效。
                </p>

                <p class="project-description">
                  <span><b>用法：</b></span>
                </p>

                <p class="project-description">
                  (一)转
                  运：当一个人感觉自己的运程不顺时，如买万字中字不中钱，工程完毕收不到钱，工作做好仍会挨骂，被人扒荷包，丢失手机等，便可在沐浴时，在清水中添加『万
                  佛神奇液』，从头洗到脚，一洗身上的霉气。据了解，这种『万佛神奇液』具有类似冲花凉的用意；所不同的是，使用者无须到指定的道场，只须在家里，当作日常
                  沐浴即可。由於『万佛神奇液』是经过玄学家苗大的大力加持与施法所配制，功效奇佳。凡用过『万佛神奇液』的人都大讚神奇液芬香扑鼻，精神爽朗、灵感泉涌、思路清晰，用後全身舒畅、信心洋溢。
                </p>

                <p class="project-description">
                  (二)人缘：时常用『万佛神奇液』沐浴，有助於增进人缘：这是因为神奇液除了具有提神醒脑的作用之外，沐浴後感觉身体有一种清新自然的薰香，使人心情开朗，笑口常开，与同事们相处融洽，广结善缘，四处有貴人，有助业务提升，做事业的处处充满无限商机。『万佛神奇液』与『万佛神香油』沿用同样的罐庄设计，色泽纯清，具有环保的意識。据了解，苗大玄学家是循大众的要求，继『万佛神香油』成功在市场占一席位後，再接再励，并用了两年的时间精心研制，把传统的沐浴露精华，加以革新精进，大力加持，使得『万佛神奇液』灵力大大提升，并方便普罗大众，共沾福澤，造福有心人，得偿夙愿，转好运、出入平安、吉祥如意、鸿运当头、开运顺利、财源四方来!
                </p>

                <p class="project-description">
                  (三)洗新车：刚买回来簇新的轿车，一般上都会使用七色花洗礼，這时候可改用神奇液，只须倒入水桶中搅匀，用新布往新车前後洗濯一番。当然，不要忘了抹亮新车牌，有望带来好财运。
                </p>

                <p class="project-description">
                  (四)净手／净脸：神奇液也可作净手／净脸之用，尤其是当感觉自己运程不太顺，灰头灰脸时，用神奇液净手／净脸，具有改运的作用，身心特别平和，精神饱满，气定神闲，招纳贵人。
                </p>

                <p class="project-description">
                  (五)采用『万佛神奇液』时，若能配合『万佛神香油』，就能加強灵力更具双层功效，達致心想事成。
                </p>
              </div>
              <!-- /.project-description -->
            </aside>
          </div>
        </div>
      </section>
      <!-- /.section-project -->

      <RelatedProduct productCode="wan-fo-shen-qi-ye" />
    </main>
    <!-- /#main -->

    <Footer />
  </div>
</template>

<script>
/* eslint-disable */
import NavBar from "../partials/NavBar.vue";
import Footer from "../partials/Footer.vue";
import RelatedProduct from "./RelatedProduct.vue";

export default {
  name: "WanFoShenQiYe",
  data() {
    return {};
  },
  components: {
    NavBar,
    Footer,
    RelatedProduct
  },
  created() {}
};
</script>



// WEBPACK FOOTER //
// src/components/products/WanFoShenQiYe.vue